let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kPf5l")).then(() => parcelRequire('9w44o'));